import React from 'react';
import { resolveSlotComponent } from '../ComponentRegistry.jsx';
import { SlimHeader } from '../components/headers/SlimHeader.jsx';

export function HeaderSlot({
  variant,
  tenant,
  cartCount = 0,
  onOpenCart,
  onNavigate,
  onSearch,
  currentPath = '/',
  ...props
}) {
  const requestedVariant =
    variant ||
    tenant?.settings?.layout_header ||
    tenant?.layout_header ||
    'slim';

  const HeaderComponent = resolveSlotComponent('header', requestedVariant) || SlimHeader;

  return (
    <HeaderComponent
      tenant={tenant}
      cartCount={cartCount}
      onOpenCart={onOpenCart}
      onNavigate={onNavigate}
      onSearch={onSearch}
      currentPath={currentPath}
      {...props}
    />
  );
}
